'use strict';
var React = require('react');
var FormatMessage = require('react-globalize').FormatMessage;

var SectionOthersServices = React.createClass({

    getInitialState() {

        var imgPath1, imgPath2, imgPath3;

        if (this.props.locale == 'es') {
            imgPath1 = 'img/icons/bfgIconMoney.jpg';
            imgPath2 = 'img/icons/bfgIconLoan.jpg';
            imgPath3 = 'img/icons/bfgIconChecks.jpg';
        } else {

            imgPath1 = 'img/icons/bfgIconMoney_en.png';
            imgPath2 = 'img/icons/bfgIconLoan_en.png';
            imgPath3 = 'img/icons/bfgIconChecks_en.png';
        }
        return {
            locale: this.props.locale, imgSendMoney: imgPath1, imgChecks: imgPath2, imgLoans: imgPath3

        };
    },


    componentWillReceiveProps: function (nextProps) {


        if (!(this.props.locale == nextProps.locale)) {
            var imgPath1, imgPath2, imgPath3;

            if (nextProps.locale == 'es') {
                imgPath1 = 'img/icons/bfgIconMoney.jpg';
                imgPath2 = 'img/icons/bfgIconLoan.jpg';
                imgPath3 = 'img/icons/bfgIconChecks.jpg';
            } else {
                imgPath1 = 'img/icons/bfgIconMoney_en.png';
                imgPath2 = 'img/icons/bfgIconLoan_en.png';
                imgPath3 = 'img/icons/bfgIconChecks_en.png';
            }
            this.setState({
                imgSendMoney: imgPath1, imgChecks: imgPath2, imgLoans: imgPath3
            });

        }
    },

    componentDidMount() {
        this.props.logPageView();
    },

    /**
     * @return {object}
     */
    render: function () {
        return (
            <section id="section11" className="content-section about-section sectionPage">
                <div className="container">
                    <h2 className="text-center"><FormatMessage locale={this.props.locale}
                        path="otherServicesPage/otherServicesTitle" /></h2>
                    <hr className="small" />
                    <div className="row">
                        <div className="col-md-12 col-md-offset-2 col-xs-10 col-xs-offset-1"><p className="text-left">
                            <strong><FormatMessage locale={this.props.locale}
                                path="otherServicesPage/otherServicesDescription1" /></strong></p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-10 col-md-offset-2 col-xs-10 col-xs-offset-1">
                            <div className="row">
                                <div className="col-xs-6 col-md-3">
                                    <ul className="list-unstyled checked-list">
                                        <li className="list-devider"></li>
                                        <li><i className="fa fa-check fa-inverse"></i><FormatMessage
                                            locale={this.props.locale} path="otherServicesPage/otherServicesList2" />
                                        </li>
                                        <li className="list-devider"></li>
                                        <li><i className="fa fa-check fa-inverse"></i><FormatMessage
                                            locale={this.props.locale} path="otherServicesPage/otherServicesList3" />
                                        </li>
                                        <li className="list-devider"></li>
                                        <li><i className="fa fa-check fa-inverse"></i><FormatMessage
                                            locale={this.props.locale} path="otherServicesPage/otherServicesList4" />
                                        </li>
                                        <li className="list-devider"></li>
                                    </ul>
                                </div>
                                <div className="col-xs-6 col-md-3">
                                    <ul className="list-unstyled checked-list">
                                        <li><i className="fa fa-check fa-inverse"></i><FormatMessage
                                            locale={this.props.locale} path="otherServicesPage/otherServicesList6" />
                                        </li>
                                        <li className="list-devider"></li>
                                        <li><i className="fa fa-check fa-inverse"></i><FormatMessage
                                            locale={this.props.locale} path="otherServicesPage/otherServicesList7" />
                                        </li>
                                        <li className="list-devider"></li>
                                        <li><i className="fa fa-check fa-inverse"></i><FormatMessage
                                            locale={this.props.locale} path="otherServicesPage/otherServicesList8" />
                                        </li>
                                        <li className="list-devider"></li>
                                        <li><i className="fa fa-check fa-inverse"></i><FormatMessage
                                            locale={this.props.locale} path="otherServicesPage/otherServicesList9" />
                                        </li>
                                        <li className="list-devider"></li>
                                        {/*<li><i className="fa fa-check fa-inverse"></i><FormatMessage
                                            locale={this.props.locale} path="otherServicesPage/otherServicesList10" />
        </li>*/}
                                    </ul>
                                </div>
                                <div
                                    className="col-md-3 col-md-offset-0 col-sm-6 col-sm-offset-3 col-xs-7 col-xs-offset-3">
                                    <img className="img-responsive img-services" src={this.state.imgSendMoney} />
                                    <img className="img-responsive img-services" src={this.state.imgChecks} />
                                    <img className="img-responsive img-services" src={this.state.imgLoans} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-10 col-sm-offset-1 col-xs-10 col-xs-offset-1"><p><FormatMessage
                        locale={this.props.locale} path="otherServicesPage/otherServicesDescription3" /> <strong>1-800-926-2277</strong>.
                    </p></div>
                </div>
                <div className="row">
                    <div className="col-sm-10 col-sm-offset-1 col-xs-10 col-xs-offset-1"><p><FormatMessage
                        locale={this.props.locale} path="otherServicesPage/otherServicesDescription2" /> <strong>1-800-926-2277</strong>.
                    </p></div>
                </div>
                <div className="row">
                    <div className="col-md-6 col-xs-12 col-md-offset-3 text-center">
                        <img className="img-responsive" src="/img/TexasLotery2022.jpg" />
                    </div>
                </div>
            </section>
        )
    }

});

module.exports = SectionOthersServices



// WEBPACK FOOTER //
// ./js/sectionOthersServices.js